import React, { Component } from 'react';
import PropTypes from 'prop-types';

const styles = {
  cell: {
    height: 75,
    padding: 15,
  },
};

export default class PageItem extends Component {
  prettyTime(string, pad, length) {
    return (new Array(length + 1).join(pad) + string).slice(-length);
  }

  esportDataFormat(esport) {
    return (
      <div className="entry-item-esport-icon"><img className="fit-height" role="presentation" src={`/assets/img/icons/${esport}.png`} /></div>
    );
  }

  typeDataFormat(type) {
    let icon = '';
    if (type === 'youtube') {
      icon = 'video.png';
    } else if (type === 'article') {
      icon = 'article.png';
    }
    return (
      <div className="entry-item-esport-icon"><img className="fit-height" role="presentation" src={`/assets/img/icons/${icon}`} /></div>
    );
  }

  render() {
    const { page, entry } = this.props;
    const session = page.metrics[0].values[0];
    const avgTime = page.metrics[0].values[1];
    const pageViews = page.metrics[0].values[2];
    const minutes = Math.floor(avgTime / 60);
    const seconds = Math.floor(avgTime % 60);
    const time = `${this.prettyTime(minutes, '0', 2)}:${this.prettyTime(seconds, '0', 2)}`;

    const icon = this.typeDataFormat(entry.type);
    const esport = this.esportDataFormat(entry.esport);
    const title = entry.title;
    return (
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ ...styles.cell, flex: 1 }}>{esport}</div>
        <div style={{ ...styles.cell, flex: 1 }}>{icon}</div>
        <div style={{ ...styles.cell, flex: 10 }}>{title}</div>
        <div style={{ ...styles.cell, flex: 1.5 }}>{session}</div>
        <div style={{ ...styles.cell, flex: 1.5 }}>{time}</div>
        <div style={{ ...styles.cell, flex: 1.5 }}>{pageViews}</div>
      </div>
    );
  }
}

PageItem.propTypes = {
  page: PropTypes.object,
  entry: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/cms/dashboard/PageItem.js